import { render, staticRenderFns } from "./login-control.vue?vue&type=template&id=2a3a399f&scoped=true"
import script from "./login-control.vue?vue&type=script&lang=ts"
export * from "./login-control.vue?vue&type=script&lang=ts"
import style0 from "./login-control.vue?vue&type=style&index=0&id=2a3a399f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3a399f",
  null
  
)

export default component.exports